/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_UpInputs */



/**
* | output |
* | --- |
* | "Move Word Up" |
*
* @param {Shortcut_Keys_Name_Move_Word_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_up = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers le haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wort nach oben verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la parola in alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить слово вверх")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover palabra hacia arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向上移动单词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を上に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द को ऊपर ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover a palavra para cima")
	return /** @type {LocalizedString} */ ("Move Word Up")
});